import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserDto } from '../model/dto/UserDto';
import { RequestResponse } from '../model/dto/RequestResponse';
import { ValidateEmailDto } from '../model/dto/ValidateEmailDto';
import { UserCredential } from '../model/UserCredential';
import { UserCredentialDto } from '../model/dto/UserCredentialDto';
import { UserRole } from '../model/UserRole';
import { UserPermission } from '../model/UserPermission';

@Injectable()
export class SecurityFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    // ValidateToken(tokenToValidate: string): Observable<RequestResponse<UserDto>> {
    //     return this._httpClient.get<RequestResponse<UserDto>>(this._urlBase + 'api/User?token=' + tokenToValidate);
    // }

    ValidateToken(token: string): Observable<RequestResponse<UserDto>> {
        return this._httpClient.post<RequestResponse<UserDto>>(this._urlBase + 'api/User/ValidateToken', { tokenString: token });
    }

    ValidateEmail(emailToValidate: string, language: number): Observable<RequestResponse<ValidateEmailDto>> {
        return this._httpClient.get<RequestResponse<ValidateEmailDto>>(this._urlBase + 'api/User/ValidateEmail?email=' + emailToValidate + '&&language='+language)
    }

    public GetUsersCredential(): Observable<RequestResponse<UserCredential[]>> {
        return this._httpClient.get<RequestResponse<UserCredential[]>>(this._urlBase + 'api/User/GetCredentials');
    }

    public AddUserCredential(user: UserCredentialDto): Observable<RequestResponse<UserCredential>> {
        return this._httpClient.post<RequestResponse<UserCredential>>(this._urlBase + 'api/User/AddCredential', user);
    }

    public UpdateUserCredential(user: UserCredentialDto): Observable<RequestResponse<UserCredential>> {
        return this._httpClient.put<RequestResponse<UserCredential>>(this._urlBase + 'api/User/UpdateCredential', user);
    }

    public GetRoles(account?: string): Observable<RequestResponse<UserRole[]>> {
        let params: HttpParams = new HttpParams();
        if (account)
            params = params.append('account', account.toString());

        return this._httpClient.get<RequestResponse<UserRole[]>>(this._urlBase + 'api/User/GetRoles', { params });
    }

    public UpdateUserRoles(userAccount: string, roles: UserRole[]): Observable<RequestResponse<UserRole[]>> {
        return this._httpClient.put<RequestResponse<UserRole[]>>(this._urlBase + 'api/User/UpdateUserRoles', { userAccount, roles });
    }

    public GetPermissions(roleId?: number): Observable<RequestResponse<UserPermission[]>> {
        let params: HttpParams = new HttpParams();
        if (roleId)
            params = params.append('roleId', roleId.toString());

        return this._httpClient.get<RequestResponse<UserPermission[]>>(this._urlBase + 'api/User/GetPermissions', { params });
    }

    public UpdateRolePermissions(role: UserRole, permissions: UserPermission[]): Observable<RequestResponse<UserPermission[]>> {
        return this._httpClient.put<RequestResponse<UserPermission[]>>(this._urlBase + 'api/User/UpdateRolePermissions', { role, permissions });
    }
}
